export const entityTypeOptions = [
  {
    value: "LLC",
    description: "LLC",
  },
  {
    value: "Corporation or Professional Corporation",
    description: "Corporation or Professional Corporation",
  },
  {
    value: "Partnership",
    description: "Partnership",
  },
  {
    value: "Sole Proprietorship",
    description: "Sole Proprietorship",
  },
  {
    value: "Single-Member LLC",
    description: "Single-Member LLC",
  },
];

export const stateOption = [
  { value: "Alabama", description: "AL" },
  { value: "Alaska", description: "AK" },
  { value: "Arizona", description: "AZ" },
  { value: "Arkansas", description: "AR" },
  { value: "California", description: "CA" },
  { value: "Colorado", description: "CO" },
  { value: "Connecticut", description: "CT" },
  { value: "Delaware", description: "DE" },
  { value: "District of Columbia", description: "DC" },
  { value: "Florida", description: "FL" },
  { value: "Georgia", description: "GA" },
  { value: "Hawaii", description: "HI" },
  { value: "Idaho", description: "ID" },
  { value: "Illinois", description: "IL" },
  { value: "Indiana", description: "IN" },
  { value: "Iowa", description: "IA" },
  { value: "Kansas", description: "KS" },
  { value: "Kentucky", description: "KY" },
  { value: "Louisiana", description: "LA" },
  { value: "Maine", description: "ME" },
  { value: "Maryland", description: "MD" },
  { value: "Massachusetts", description: "MA" },
  { value: "Michigan", description: "MI" },
  { value: "Minnesota", description: "MN" },
  { value: "Mississippi", description: "MS" },
  { value: "Missouri", description: "MO" },
  { value: "Montana", description: "MT" },
  { value: "Nebraska", description: "NE" },
  { value: "Nevada", description: "NV" },
  { value: "New Hampshire", description: "NH" },
  { value: "New Jersey", description: "NJ" },
  { value: "New Mexico", description: "NM" },
  { value: "New York", description: "NY" },
  { value: "North Carolina", description: "NC" },
  { value: "North Dakota", description: "ND" },
  { value: "Ohio", description: "OH" },
  { value: "Oklahoma", description: "OK" },
  { value: "Oregon", description: "OR" },
  { value: "Pennsylvania", description: "PA" },
  { value: "Rhode Island", description: "RI" },
  { value: "South Carolina", description: "SC" },
  { value: "South Dakota", description: "SD" },
  { value: "Tennessee", description: "TN" },
  { value: "Texas", description: "TX" },
  { value: "Utah", description: "UT" },
  { value: "Vermont", description: "VT" },
  { value: "Virginia", description: "VA" },
  { value: "Washington", description: "WA" },
  { value: "West Virginia", description: "WV" },
  { value: "Wisconsin", description: "WI" },
  { value: "Wyoming", description: "WY" },
];

export const officeLocationOptions = [
  { value: "Main Office", description: "Main Office" },
  { value: "New Office Address", description: "New Office Address" },
  { value: "Remote", description: "Remote" },
];

export const employeeTypeOptions = [
  {
    value: "Employee - Full Time (W-2)",
    description: "Employee - Full Time (W-2)",
  },
  {
    value: "Employee - Part Time (W-2)",
    description: "Employee - Part Time (W-2)",
  },
];

export const numberOfVolunteersOptions = [
  { value: "1-3", description: "1-3" },
  { value: "4-6", description: "4-6" },
  { value: "7-10", description: "7-10" },
  { value: "10+", description: "10+" },
];

export const travelFrequencyOptions = [
  { value: "1", description: "1" },
  { value: "2-3", description: "2-3" },
  { value: "4-5", description: "4-5" },
  { value: "6-10", description: "6-10" },
  {
    value: "10+",
    description: "10+",
  },
];

export const percentageOptions = [
  { value: "1-25 %", description: "1-25 %" },
  { value: "26-50 %", description: "26-50 %" },
  { value: "51-75 %", description: "51-75 %" },
  { value: "76-100 %", description: "76-100 %" },
];

export const contractorNumberOption = [
  { value: "1-10", description: "1-10" },
  { value: "11-20", description: "11-20" },
  { value: "21-50", description: "21-50" },
  { value: "51+", description: "51+" },
];

export const employeeDurationOptions = [
  { value: "1-2 weeks", description: "1-2 weeks" },
  { value: "2-4 weeks", description: "2-4 weeks" },
  { value: "1 month", description: "1 month" },
  { value: "More than 1 month", description: "More than 1 month" },
];

export const deliveryFrequencyOptions = [
  { value: "1-2 days a week", description: "1-2 days a week" },
  { value: "3-5 days a week", description: "3-5 days a week" },
  { value: "7 days a week", description: "7 days a week" },
  { value: "Other", description: "Other" },
];

export const deliveryDistanceOptions = [
  { value: "0-20", description: "0-20" },
  { value: "21-50", description: "21-50" },
  { value: "51-100", description: "51-100" },
  { value: "100+", description: "100+" },
];

export const deliveryTransportationTypeOptions = [
  { value: "Personal vehicle", description: "Personal vehicle" },
  {
    value: "Company owned/Leased vehicle",
    description: "Company owned/Leased vehicle",
  },
  {
    value: "Company owned/Leased Truck/Van",
    description: "Company owned/Leased Truck/Van",
  },
  { value: "Other", description: "Other" },
];

export const occupationOptions = [
  { value: "Teacher/teacher’s aide", description: "Teacher/teacher’s aide" },
  { value: "Supervisor", description: "Supervisor" },
  { value: "Manager", description: "Manager" },
  { value: "Team member", description: "Team member" },
];

export const exactAgesOptions = [
  { value: "<16 years", description: "<16 years" },
  { value: "60-70 years", description: "60-70 years" },
  { value: "71-80 years", description: "71-80 years" },
  { value: "81+ years", description: "81+ years" },
];

// remove commas from country names
export const countryOptions = [
  { value: "Afghanistan", description: "Afghanistan" },
  { value: "Aland Islands", description: "Aland Islands" },
  { value: "American Samoa", description: "American Samoa" },
  { value: "Anguilla", description: "Anguilla" },
  { value: "Antarctica", description: "Antarctica" },
  { value: "Antigua and Barbuda", description: "Antigua and Barbuda" },
  { value: "Argentina", description: "Argentina" },
  { value: "Armenia", description: "Armenia" },
  { value: "Aruba", description: "Aruba" },
  { value: "Australia", description: "Australia" },
  { value: "Austria", description: "Austria" },
  { value: "Azerbaijan", description: "Azerbaijan" },
  { value: "Bahamas", description: "Bahamas" },
  { value: "Bahrain", description: "Bahrain" },
  { value: "Bangladesh", description: "Bangladesh" },
  { value: "Barbados", description: "Barbados" },
  { value: "Belarus", description: "Belarus" },
  { value: "Belgium", description: "Belgium" },
  { value: "Belize", description: "Belize" },
  { value: "Benin", description: "Benin" },
  { value: "Bermuda", description: "Bermuda" },
  { value: "Bhutan", description: "Bhutan" },
  { value: "Bolivia", description: "Bolivia" },
  { value: "Bosnia and Herzegovina", description: "Bosnia and Herzegovina" },
  { value: "Botswana", description: "Botswana" },
  { value: "Bouvet Island", description: "Bouvet Island" },
  { value: "Brazil", description: "Brazil" },
  {
    value: "British Indian Ocean Territory",
    description: "British Indian Ocean Territory",
  },
  { value: "Brunei Darussalam", description: "Brunei Darussalam" },
  { value: "Bulgaria", description: "Bulgaria" },
  { value: "Burkina Faso", description: "Burkina Faso" },
  { value: "Burundi", description: "Burundi" },
  { value: "Cambodia", description: "Cambodia" },
  { value: "Cameroon", description: "Cameroon" },
  { value: "Canada", description: "Canada" },
  { value: "Cape Verde", description: "Cape Verde" },
  { value: "Cayman Islands", description: "Cayman Islands" },
  {
    value: "Central African Republic",
    description: "Central African Republic",
  },
  { value: "Chad", description: "Chad" },
  { value: "Chile", description: "Chile" },
  { value: "China", description: "China" },
  { value: "Christmas Island", description: "Christmas Island" },
  { value: "Cocos (Keeling) Islands", description: "Cocos (Keeling) Islands" },
  { value: "Colombia", description: "Colombia" },
  { value: "Comoros", description: "Comoros" },
  { value: "Congo", description: "Congo" },
  {
    value: "Democratic Republic of the Congo",
    description: "Democratic Republic of the Congo",
  },
  { value: "Cook Islands", description: "Cook Islands" },
  { value: "Costa Rica", description: "Costa Rica" },
  { value: "Cote D'Ivoire", description: "Cote D'Ivoire" },
  { value: "Croatia", description: "Croatia" },
  { value: "Cuba", description: "Cuba" },
  { value: "Cyprus", description: "Cyprus" },
  { value: "Czech Republic", description: "Czech Republic" },
  { value: "Denmark", description: "Denmark" },
  { value: "Djibouti", description: "Djibouti" },
  { value: "Dominica", description: "Dominica" },
  { value: "Dominican Republic", description: "Dominican Republic" },
  { value: "Ecuador", description: "Ecuador" },
  { value: "Egypt", description: "Egypt" },
  { value: "El Salvador", description: "El Salvador" },
  { value: "Equatorial Guinea", description: "Equatorial Guinea" },
  { value: "Eritrea", description: "Eritrea" },
  { value: "Estonia", description: "Estonia" },
  { value: "Ethiopia", description: "Ethiopia" },
  {
    value: "Falkland Islands (Malvinas)",
    description: "Falkland Islands (Malvinas)",
  },
  { value: "Faroe Islands", description: "Faroe Islands" },
  { value: "Fiji", description: "Fiji" },
  { value: "Finland", description: "Finland" },
  { value: "France", description: "France" },
  { value: "French Guiana", description: "French Guiana" },
  { value: "French Polynesia", description: "French Polynesia" },
  {
    value: "French Southern Territories",
    description: "French Southern Territories",
  },
  { value: "Gabon", description: "Gabon" },
  { value: "Gambia", description: "Gambia" },
  { value: "Georgia", description: "Georgia" },
  { value: "Germany", description: "Germany" },
  { value: "Ghana", description: "Ghana" },
  { value: "Gibraltar", description: "Gibraltar" },
  { value: "Greece", description: "Greece" },
  { value: "Greenland", description: "Greenland" },
  { value: "Grenada", description: "Grenada" },
  { value: "Guadeloupe", description: "Guadeloupe" },
  { value: "Guam", description: "Guam" },
  { value: "Guatemala", description: "Guatemala" },
  { value: "Guernsey", description: "Guernsey" },
  { value: "Guinea", description: "Guinea" },
  { value: "Guinea-Bissau", description: "Guinea-Bissau" },
  { value: "Guyana", description: "Guyana" },
  { value: "Haiti", description: "Haiti" },
  {
    value: "Heard Island & Mcdonald Islands",
    description: "Heard Island & Mcdonald Islands",
  },
  {
    value: "Holy See (Vatican City State)",
    description: "Holy See (Vatican City State)",
  },
  { value: "Honduras", description: "Honduras" },
  { value: "Hong Kong", description: "Hong Kong" },
  { value: "Hungary", description: "Hungary" },
  { value: "Iceland", description: "Iceland" },
  { value: "India", description: "India" },
  { value: "Indonesia", description: "Indonesia" },
  {
    value: "Islamic Republic Of Iran",
    description: "Islamic Republic Of Iran",
  },
  { value: "Iraq", description: "Iraq" },
  { value: "Ireland", description: "Ireland" },
  { value: "Isle Of Man", description: "Isle Of Man" },
  { value: "Israel", description: "Israel" },
  { value: "Italy", description: "Italy" },
  { value: "Jamaica", description: "Jamaica" },
  { value: "Japan", description: "Japan" },
  { value: "Jersey", description: "Jersey" },
  { value: "Jordan", description: "Jordan" },
  { value: "Kazakhstan", description: "Kazakhstan" },
  { value: "Kenya", description: "Kenya" },
  { value: "Kiribati", description: "Kiribati" },
  { value: "Korea", description: "Korea" },
  { value: "North Korea", description: "North Korea" },
  { value: "Kuwait", description: "Kuwait" },
  { value: "Kyrgyzstan", description: "Kyrgyzstan" },
  {
    value: "Lao People's Democratic Republic",
    description: "Lao People's Democratic Republic",
  },
  { value: "Latvia", description: "Latvia" },
  { value: "Lebanon", description: "Lebanon" },
  { value: "Lesotho", description: "Lesotho" },
  { value: "Liberia", description: "Liberia" },
  { value: "Libyan Arab Jamahiriya", description: "Libyan Arab Jamahiriya" },
  { value: "Liechtenstein", description: "Liechtenstein" },
  { value: "Lithuania", description: "Lithuania" },
  { value: "Luxembourg", description: "Luxembourg" },
  { value: "Macao", description: "Macao" },
  { value: "Macedonia", description: "Macedonia" },
  { value: "Madagascar", description: "Madagascar" },
  { value: "Malawi", description: "Malawi" },
  { value: "Malaysia", description: "Malaysia" },
  { value: "Maldives", description: "Maldives" },
  { value: "Mali", description: "Mali" },
  { value: "Malta", description: "Malta" },
  { value: "Marshall Islands", description: "Marshall Islands" },
  { value: "Martinique", description: "Martinique" },
  { value: "Mauritania", description: "Mauritania" },
  { value: "Mauritius", description: "Mauritius" },
  { value: "Mayotte", description: "Mayotte" },
  { value: "Mexico", description: "Mexico" },
  {
    value: "Federated States Of Micronesia",
    description: "Federated States Of Micronesia",
  },
  { value: "Moldova", description: "Moldova" },
  { value: "Monaco", description: "Monaco" },
  { value: "Mongolia", description: "Mongolia" },
  { value: "Montenegro", description: "Montenegro" },
  { value: "Montserrat", description: "Montserrat" },
  { value: "Morocco", description: "Morocco" },
  { value: "Mozambique", description: "Mozambique" },
  { value: "Myanmar", description: "Myanmar" },
  { value: "Namibia", description: "Namibia" },
  { value: "Nauru", description: "Nauru" },
  { value: "Nepal", description: "Nepal" },
  { value: "Netherlands", description: "Netherlands" },
  { value: "Netherlands Antilles", description: "Netherlands Antilles" },
  { value: "New Caledonia", description: "New Caledonia" },
  { value: "New Zealand", description: "New Zealand" },
  { value: "Nicaragua", description: "Nicaragua" },
  { value: "Niger", description: "Niger" },
  { value: "Nigeria", description: "Nigeria" },
  { value: "Niue", description: "Niue" },
  { value: "Norfolk Island", description: "Norfolk Island" },
  {
    value: "Northern Mariana Islands",
    description: "Northern Mariana Islands",
  },
  { value: "Norway", description: "Norway" },
  { value: "Oman", description: "Oman" },
  { value: "Pakistan", description: "Pakistan" },
  { value: "Palau", description: "Palau" },
  {
    value: "Palestinian Territory-Occupied",
    description: "Palestinian Territory-Occupied",
  },
  { value: "Panama", description: "Panama" },
  { value: "Papua New Guinea", description: "Papua New Guinea" },
  { value: "Paraguay", description: "Paraguay" },
  { value: "Peru", description: "Peru" },
  { value: "Philippines", description: "Philippines" },
  { value: "Pitcairn", description: "Pitcairn" },
  { value: "Poland", description: "Poland" },
  { value: "Portugal", description: "Portugal" },
  { value: "Puerto Rico", description: "Puerto Rico" },
  { value: "Qatar", description: "Qatar" },
  { value: "Reunion", description: "Reunion" },
  { value: "Romania", description: "Romania" },
  { value: "Russian Federation", description: "Russian Federation" },
  { value: "Rwanda", description: "Rwanda" },
  { value: "Saint Barthelemy", description: "Saint Barthelemy" },
  { value: "Saint Helena", description: "Saint Helena" },
  { value: "Saint Kitts And Nevis", description: "Saint Kitts And Nevis" },
  { value: "Saint Lucia", description: "Saint Lucia" },
  { value: "Saint Martin", description: "Saint Martin" },
  {
    value: "Saint Pierre And Miquelon",
    description: "Saint Pierre And Miquelon",
  },
  {
    value: "Saint Vincent And Grenadines",
    description: "Saint Vincent And Grenadines",
  },
  { value: "Samoa", description: "Samoa" },
  { value: "San Marino", description: "San Marino" },
  { value: "Sao Tome And Principe", description: "Sao Tome And Principe" },
  { value: "Saudi Arabia", description: "Saudi Arabia" },
  { value: "Senegal", description: "Senegal" },
  { value: "Serbia", description: "Serbia" },
  { value: "Seychelles", description: "Seychelles" },
  { value: "Sierra Leone", description: "Sierra Leone" },
  { value: "Singapore", description: "Singapore" },
  { value: "Slovakia", description: "Slovakia" },
  { value: "Slovenia", description: "Slovenia" },
  { value: "Solomon Islands", description: "Solomon Islands" },
  { value: "Somalia", description: "Somalia" },
  { value: "South Africa", description: "South Africa" },
  {
    value: "South Georgia And Sandwich Isl.",
    description: "South Georgia And Sandwich Isl.",
  },
  { value: "Spain", description: "Spain" },
  { value: "Sri Lanka", description: "Sri Lanka" },
  { value: "Sudan", description: "Sudan" },
  { value: "Suriname", description: "Suriname" },
  { value: "Svalbard And Jan Mayen", description: "Svalbard And Jan Mayen" },
  { value: "Swaziland", description: "Swaziland" },
  { value: "Sweden", description: "Sweden" },
  { value: "Switzerland", description: "Switzerland" },
  { value: "Syrian Arab Republic", description: "Syrian Arab Republic" },
  { value: "Taiwan", description: "Taiwan" },
  { value: "Tajikistan", description: "Tajikistan" },
  { value: "Tanzania", description: "Tanzania" },
  { value: "Thailand", description: "Thailand" },
  { value: "Timor-Leste", description: "Timor-Leste" },
  { value: "Togo", description: "Togo" },
  { value: "Tokelau", description: "Tokelau" },
  { value: "Tonga", description: "Tonga" },
  { value: "Trinidad And Tobago", description: "Trinidad And Tobago" },
  { value: "Tunisia", description: "Tunisia" },
  { value: "Turkey", description: "Turkey" },
  { value: "Turkmenistan", description: "Turkmenistan" },
  {
    value: "Turks And Caicos Islands",
    description: "Turks And Caicos Islands",
  },
  { value: "Tuvalu", description: "Tuvalu" },
  { value: "Uganda", description: "Uganda" },
  { value: "Ukraine", description: "Ukraine" },
  { value: "United Arab Emirates", description: "United Arab Emirates" },
  { value: "United Kingdom", description: "United Kingdom" },
  { value: "United States", description: "United States" },
  { value: "Uruguay", description: "Uruguay" },
  { value: "Uzbekistan", description: "Uzbekistan" },
  { value: "Vanuatu", description: "Vanuatu" },
  { value: "Venezuela", description: "Venezuela" },
  { value: "Vietnam", description: "Vietnam" },
  { value: "Western Sahara", description: "Western Sahara" },
  { value: "Yemen", description: "Yemen" },
  { value: "Zambia", description: "Zambia" },
  { value: "Zimbabwe", description: "Zimbabwe" },
];
